import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TextTooltipModule } from '@lib/components';
import { AmountFormatModule, DateFormatModule, StaticMsgModule } from '@lib/pipes';
import { SeatReservationComponent } from './seat-reservation.component';
import { TableSliderModule } from '@common/components/feature-part/table-slider/table-slider.module';
import { MilesFormatModule } from '@common/pipes/miles-format/miles-format.module';
import { TooltipDirectiveModule } from '@lib/directives';
import { SeatReservationItemModule } from './seat-reservation-item/seat-reservation-item.module';

@NgModule({
  declarations: [SeatReservationComponent],
  imports: [
    CommonModule,
    TextTooltipModule,
    TooltipDirectiveModule,
    TableSliderModule,
    StaticMsgModule,
    AmountFormatModule,
    DateFormatModule,
    MilesFormatModule,
    SeatReservationItemModule,
  ],
  exports: [SeatReservationComponent],
})
export class SeatReservationModule {}
